module.exports = __webpack_public_path__ + "static/img/Harris-Andrews.c2497bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Harris-Andrews.jpg
// module id = 8lb0
// module chunks = 0